import React, { useRef, useState, useEffect } from 'react';
import { useSpring, animated, config } from 'react-spring';
import '../styles.css';
import { connect } from 'react-redux';
import _ from 'lodash';
import QuestionIcon from '../ASSETS/OptionHelp.png';
import { HELP_PAGE } from '../../HOME/const';
import { MOVE_DURATION } from '../const';

const Card = props => {
  const { card, stack, boardId } = props;
  let { question, peg, hole, yens, selected } = card;
  const help = props.page === HELP_PAGE;
  const init = boardId && props.init === boardId;
  const width = help ? '70px' : '22vw';
  const height = help ? '105px' : '33vw';
  const pegWidth = help ? 13 : 17;
  const holeWidth = help ? 3 : 4;
  const pegSize = `${pegWidth}px`;
  const yenSize = `${pegWidth + holeWidth * 2}px`;
  const l = useRef({});
  const flip = (card.row + card.col) % 2 ? 'X' : 'Y';
  let dx = 0;
  let dy = 0;

  if (selected && stack) {
    dx = (stack.col - card.col) * (l.current.rect.width + 6);
    dy = (stack.row - card.row) * (l.current.rect.height + 6);
  }

  const [angle, setAngle] = useState(0);
  useEffect(() => setAngle(0), [card]);

  const isTop = () => {
    return card.row === stack.row && card.col === stack.col;
  };

  const moving = init || (stack && selected && !isTop());

  const moveSpring = useSpring({
    transform: `translate(${dx}px, ${dy}px)`,
    background: `${init ? 'rgba(0,0,0,0.1)' : moving ? 'rgba(0,0,0,0)' : selected ? 'rgba(255,255,0,0.1)' : 'rgba(0,0,0,0.1)'}`,
    immediate: !moving,
    config: { duration: MOVE_DURATION },
  });

  const flipSpring = useSpring({
    transform: `rotate${flip}(${init ? 90 : 0}deg)`,
    config: { duration: MOVE_DURATION / 2 },
  });

  const overSpring = useSpring({
    transform: `rotateY(${angle}deg)`,
    delay: angle ? 0 : MOVE_DURATION,
    immediate: !angle || angle > 360,
    config: config.fast,
    onRest: () => {
      if (stack && angle <= 360) {
        setAngle(angle + 360);
      }
    },
  });

  return (
    <animated.div style={{ transform: moveSpring.transform }}>
      <animated.div style={{ transform: overSpring.transform }}>
        <animated.div
          className="re-card"
          ref={el => {
            if (el) {
              l.current.rect = el.getBoundingClientRect();
            }
          }}
          style={{
            width,
            height,
            borderWidth: `${help ? 3 : 4}px`,
            background: moveSpring.background,
            transform: flipSpring.transform,
          }}>
          {question && (
            <div style={{ gridArea: '1/1/span3/span2', alignSelf: 'center', justifySelf: 'center' }}>
              <img src={QuestionIcon} alt="help" />
            </div>
          )}
          {peg && (
            <div
              style={{
                gridArea: `${peg.area}`,
                background: `${peg.color}`,
                width: pegSize,
                height: pegSize,
                borderRadius: '50%',
                alignSelf: 'center',
                justifySelf: 'center',
              }}
            />
          )}
          {hole && (
            <div
              style={{
                gridArea: `${hole.area}`,
                border: `${holeWidth}px solid ${hole.color}`,
                width: pegSize,
                height: pegSize,
                borderRadius: '50%',
                alignSelf: 'center',
                justifySelf: 'center',
              }}
            />
          )}
          {yens &&
            _.map(yens, (yen, i) => {
              return (
                <div
                  key={i}
                  className="re-yen"
                  style={{ gridArea: `${yen.area}`, background: `${yen.color}`, width: `${yenSize}`, height: `${yenSize}` }}>
                  <span style={{ marginTop: '-1px' }}>¥</span>
                </div>
              );
            })}
        </animated.div>
      </animated.div>
    </animated.div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Card);
